var _rect, _path, _path2, _path3, _path4, _path5, _path6, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _ellipse, _ellipse2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 524,
    height: 299,
    viewBox: "0 0 524 299",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 117.43000030517578,
    width: 497.00003048308986,
    height: 181.57001495361328,
    fill: "#001866",
    fillOpacity: 0.04
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgba(255, 255, 255, 1)",
    d: "M524 117.43L27 117.43L27 299L524 299L524 117.43ZM28 298L28 118.43L523 118.43L523 298L28 298Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0308 280.853L508.229 280.853L523.759 297.865L27.5005 297.865L43.0308 280.853Z",
    fill: "url(#linear_fill_3_27)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.54 125.36L25.41 125.36L25.41 130.16L27.54 130.16L27.54 125.36ZM27.54 293.45L25.41 293.45L25.41 298.25L27.54 298.25L27.54 293.45Z",
    fillRule: "evenodd",
    fill: "#1FCDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M523.99 125.36L521.86 125.36L521.86 130.16L523.99 130.16L523.99 125.36ZM523.99 293.45L521.86 293.45L521.86 298.25L523.99 298.25L523.99 293.45Z",
    fillRule: "evenodd",
    fill: "#1FCDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(255, 255, 255, 1)",
    strokeWidth: 1.0872523784637451,
    d: "M27.22 189.12L27.22 245.11"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(255, 255, 255, 1)",
    strokeWidth: 1.0872523784637451,
    d: "M522.92 189.12L522.92 245.11"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 117,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 126.16999816894531,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 119.29000091552734,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 121.58000183105469,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 123.87000274658203,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 135.3300018310547,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 128.45999145507812,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 130.75,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 133.0399932861328,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 145.25999450683594,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 138.38999938964844,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 140.67999267578125,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 142.97000122070312,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 162.35995483398438,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 147.55999755859375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 157.77996826171875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 160.0699462890625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 171.52996826171875,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 164.64996337890625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 166.93994140625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 169.23995971679688,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 180.68994140625,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 173.8199462890625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 176.10995483398438,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 178.39996337890625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 190.61996459960938,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 182.98995971679688,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 185.27996826171875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 188.3299560546875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 199.78994750976562,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 192.91995239257812,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 195.2099609375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 197.49996948242188,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 208.9599609375,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 202.0799560546875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 204.36996459960938,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 206.66995239257812,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 218.11996459960938,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 211.24996948242188,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 213.53994750976562,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 215.8299560546875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 228.04995727539062,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 220.41995239257812,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 222.7099609375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 224.99996948242188,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 237.21994018554688,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 230.34994506835938,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 232.63995361328125,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 234.92996215820312,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 246.38995361328125,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 239.50994873046875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 241.79995727539062,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 244.09994506835938,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 263.47991943359375,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 248.67996215820312,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 258.89990234375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 261.1899108886719,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 272.64990234375,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 265.7799072265625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 268.0699157714844,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 270.35992431640625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 282.57989501953125,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 274.93988037109375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 277.99993896484375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 280.2899169921875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 284.86993408203125,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 287.169921875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 117,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 126.16999816894531,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 119.29000091552734,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 121.58000183105469,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 123.87000274658203,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 135.3300018310547,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 128.45999145507812,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 130.75,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 133.0399932861328,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 145.25999450683594,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 138.38999938964844,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 140.67999267578125,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 142.97000122070312,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 162.35986328125,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 155.4898681640625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 157.77987670898438,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 160.0698699951172,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 171.52987670898438,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 164.64987182617188,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 166.9398651123047,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 169.2398681640625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 180.6898651123047,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 173.8198699951172,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 176.10986328125,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 178.39987182617188,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 190.619873046875,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 182.9898681640625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 185.27987670898438,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 188.32986450195312,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 199.7898712158203,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 192.9198760986328,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 195.20986938476562,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 197.4998779296875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 208.95986938476562,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 202.07986450195312,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 204.369873046875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 206.6698760986328,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 218.119873046875,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 211.2498779296875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 213.5398712158203,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 215.82986450195312,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 228.04986572265625,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 220.4198760986328,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 222.70986938476562,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 224.9998779296875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 237.21986389160156,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 230.34986877441406,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 232.63987731933594,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 234.92987060546875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 246.38986206054688,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 239.50987243652344,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 241.79986572265625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 244.09986877441406,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 263.479736328125,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 248.6798553466797,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 258.89971923828125,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 261.1897277832031,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 272.64971923828125,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 265.77972412109375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 268.0697326660156,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 270.3597412109375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 513.7300415039062,
    y: 282.5797424316406,
    width: 5.630000114440918,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 274.9397277832031,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 277.999755859375,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 280.28973388671875,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 284.8697509765625,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 516.550048828125,
    y: 287.16973876953125,
    width: 2.819999933242798,
    height: 0.7599999904632568,
    fill: "#295A91"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 290.97991943359375,
    width: 8.449999809265137,
    height: 3.059999942779541,
    fill: "#AAE1FF"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 31.489999771118164,
    y: 296.3299255371094,
    width: 25.350000381469727,
    height: 1.5299999713897705,
    fill: "#AAE1FF"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 512.3200073242188,
    y: 290.97991943359375,
    width: 8.449999809265137,
    height: 3.059999942779541,
    fill: "#AAE1FF"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 495.4200134277344,
    y: 296.3299255371094,
    width: 25.350000381469727,
    height: 1.5299999713897705,
    fill: "#AAE1FF"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 41.19001770019531,
    y: 291.74993896484375,
    width: 214.25999450683594,
    height: 1.5299999713897705,
    fill: "#05599C"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 299.80999755859375,
    y: 291.74993896484375,
    width: 211.25999450683594,
    height: 1.5299999713897705,
    fill: "#05599C"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 264.6000061035156,
    y: 291.74993896484375,
    width: 7.039999961853027,
    height: 1.5299999713897705,
    fill: "#456A94"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 283.6100158691406,
    y: 291.74993896484375,
    width: 7.039999961853027,
    height: 1.5299999713897705,
    fill: "#456A94"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 274.4599914550781,
    y: 291.74993896484375,
    width: 7.039999961853027,
    height: 1.5299999713897705,
    fill: "#88D0F8"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 259.6800109744072,
    cy: 292.509938955307,
    rx: 0.699999988079071,
    ry: 0.7599999904632568,
    fill: "#FFFFFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.2899963259697,
    cy: 292.509938955307,
    rx: 0.699999988079071,
    ry: 0.7599999904632568,
    fill: "#FFFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear_fill_3_27",
    x1: 275.62969970703125,
    y1: 280.85260009765625,
    x2: 275.62969970703125,
    y2: 297.8645935058594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1B86FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B86FF",
    stopOpacity: 0.36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder);
export default __webpack_public_path__ + "static/media/border.b9e93944e5350349620c47eed0970508.svg";
export { ForwardRef as ReactComponent };